import axios from 'axios';
import API from 'lib/RemindAPI';

function buildForm(fields: [string, string], blob: File) {
  const form = new FormData();
  const entries: [string, string][] = Object.entries(fields);
  entries.forEach(pair => form.append(...pair));
  form.append('file', blob);
  return form;
}

export async function uploadFileRequest(
  blob: File,
  privateUpload: boolean = false,
  onUploadProgress?: (percent: number) => void
): Promise<V2File> {
  // Fetch file upload address and fields from api
  const fileName = blob.name;
  const postParamsPromise = API.request('/files', 'POST', {
    file: {
      name: fileName,
    },
    private: privateUpload,
  });

  const postParams = await postParamsPromise;
  const uploadUrl = postParams.upload_url;

  // Upload file to CDN
  await axios.post(uploadUrl, buildForm(postParams.fields, blob), {
    onUploadProgress: progressEvent => {
      const progressPercentage = (progressEvent.loaded / progressEvent.total) * 100;

      if (onUploadProgress) {
        onUploadProgress(progressPercentage);
      }
    },
  });

  // Load file entity
  const fileId = postParams.id;
  return await API.request(`/files/${fileId}/ack`, 'POST');
}

export type V2File = {
  content_type: string;
  id: string;
  name: string;
  preview_height: number;
  preview_width: number;
  size: number;
  urls: { cdn: string | null; tracked: string | null };
  view_count: number;
  viewers: any[];
};

export async function fetchJSONFileByIdRequest(fileId: string): Promise<V2File> {
  const fileResponse = await API.request(`/files/${fileId}`, 'GET');
  return fileResponse;
}
